import { html, render } from "lit-html";
import { translate } from "../../../shared/l10n/translate";
import { stateful } from "../../../shared/components/element-builder";
import "../WheelSelector";
import { session } from "../../../shared/state/payload";
import {
	MAX_AGE_CHILDREN,
	MAX_NUM_ADULTS,
	MAX_NUM_CHILDREN,
	MIN_AGE_CHILDREN,
	MIN_NUM_ADULTS,
	MIN_NUM_CHILDREN,
	MAX_NUM_ROOMS,
} from "../../state/travelData";

const getDefaultRoom = () => ({ ...session.defaultRooms[0] });

class GuestSelector extends HTMLElement {
	static getInitialState() {
		return {
			rooms: [getDefaultRoom()],
		};
	}

	onNumRoomsChanged({ detail }) {
		this.rooms =
			detail < this.rooms.length
				? this.rooms.slice(0, -1)
				: [...this.rooms, getDefaultRoom()];
		this.notify();
	}

	onAdultsChanged(roomIndex) {
		return ({ detail }) => {
			this.rooms[roomIndex].adults = detail;
			this.notify();
		};
	}

	onNumChildrenChanged(roomIndex) {
		return ({ detail }) => {
			const children = this.rooms[roomIndex].children;
			this.rooms[roomIndex].children =
				detail < children.length ? children.slice(0, -1) : [...children, 0];
			this.notify();
		};
	}

	onChildrenAgeChanged(roomIndex, childIndex) {
		return ({ detail }) => {
			this.rooms[roomIndex].children[childIndex] = detail;
			this.notify();
		};
	}

	notify() {
		const event = new CustomEvent("change", {
			detail: { rooms: this.rooms },
			bubbles: true,
		});
		this.dispatchEvent(event);
	}

	render() {
		const template = html`
			<esc-wheel
				class="esc-guest-selector__room-selector"
				.min=${1}
				.max=${MAX_NUM_ROOMS}
				.value=${this.rooms.length}
				.label=${translate("basic_rooms_plural")}
				.labelSingular=${translate("basic_rooms_singular")}
				.labelPlural=${translate("basic_rooms_plural")}
				@change=${this.onNumRoomsChanged}
			></esc-wheel>
			${this.rooms.map(
				({ adults, children }, roomIndex) => html`
					<div class="esc-guest-selector__room">
						<esc-wheel
							class="esc-guest-selector__adults"
							.min=${MIN_NUM_ADULTS}
							.max=${MAX_NUM_ADULTS}
							.value=${adults}
							.label="${translate("basic_room")} ${roomIndex + 1}"
							.labelSingular=${translate("basic_adults_singular")}
							.labelPlural=${translate("basic_adults_plural")}
							@change=${this.onAdultsChanged(roomIndex)}
						></esc-wheel>
						<esc-wheel
							class="esc-guest-selector__children-selector"
							.min=${MIN_NUM_CHILDREN}
							.max=${MAX_NUM_CHILDREN}
							.value=${children.length}
							.labelSingular=${translate("basic_children_singular")}
							.labelPlural=${translate("basic_children_plural")}
							@change=${this.onNumChildrenChanged(roomIndex)}
						></esc-wheel>
						<div class="esc-guest-selector__children">
							${children.map(
								(age, childIndex) => html`
									<esc-wheel
										class="esc-guest-selector__children__age-selector"
										.min=${MIN_AGE_CHILDREN}
										.max=${MAX_AGE_CHILDREN}
										.value=${age}
										.label="${translate(
											"basic_children_singular",
										)} ${childIndex + 1}"
										.labelSingular=${translate("basic_children_ages_singular")}
										.labelPlural=${translate("basic_children_ages_plural")}
										@change=${this.onChildrenAgeChanged(roomIndex, childIndex)}
									></esc-wheel>
								`,
							)}
						</div>
					</div>
				`,
			)}
		`;
		render(template, this, { host: this });
	}
}

customElements.define("esc-guest-selector", stateful(GuestSelector));
